import styled from 'styled-components';
import { rem } from 'polished';
import breakpoints from '../utils/breakpoints';

export const Heading = styled.h1`
  @media (min-width: ${breakpoints.tablet}px) {
    font-size: ${rem(48)};
    margin-bottom: ${rem(48)};
  }
`;

const Content = styled.div`
  max-width: var(--content-max-width);
  padding: 42px 20px;

  @media (min-width: ${breakpoints.tablet}px) {
    padding: var(--method-area-padding) var(--method-area-padding);
  }
  @media (min-width: ${breakpoints.desktop}px) {
    padding: calc(var(--method-area-padding) / 2) var(--method-area-padding);
  }
`;

export default Content;
